<template>
  <div class="flex pt-5 pb-2 items-center">
    <loading-indicator v-if="isActive"></loading-indicator>
    <div class="col-md-4 col-xl-3">
      <router-link :to="{ name: 'student' }">
        <img class="logo" alt="logo" src="../../assets/images/2-lrn-spt-logo-252.svg"/>
      </router-link>
    </div>
    <div class="col-md-8 col-xl-9 pr-0">
      <div class="flex items-center justify-between">
        <div>
          <lerner-search />
        </div>
        <div class="col-2 flex items-center justify-end">
          <a href="#" class="log-1 text-grey-1 hover:text-grey-2" v-show="!isStudentOnlyUser" @click.prevent="$emit('adminLinkClicked')">Back to Admin</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LernerSearch from './LernerSearch';
  import LoadingIndicator from '@/component/LoadingIndicator';
  import { mapGetters } from 'vuex';

  export default {
    name: 'StudentHeader',

    components: {
      LoadingIndicator,
      LernerSearch
    },

    props: {
      pending: {
        default: false,
        type: Boolean
      }
    },

    computed: {
      isActive: function () {
        return this.pending || this.appPending;
      },
      ...mapGetters(['appPending', 'isStudentOnlyUser']),
    }
  }
</script>

